import { useQuery } from 'react-query'
import { socialProofApi } from 'api/socialProofApi'
import { QUERY_KEYS } from '@/lib/cache-keys/queryKeys'

export const useRecentWinners = (partnerId: string | number | undefined, enabled: boolean) => {
  return useQuery(
    [QUERY_KEYS.RECENT_WINNERS, partnerId],
    () => socialProofApi.getRecentWinners(partnerId as string | number),
    {
      enabled: enabled && !!partnerId,
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    },
  )
}
